export const SHOW_FEEDING_GUIDELINES = 'APP_SHOW_FEEDING_GUIDELINES';
